import { render, staticRenderFns } from "./role-permission.vue?vue&type=template&id=c89eff50&scoped=true&"
import script from "./role-permission.vue?vue&type=script&lang=js&"
export * from "./role-permission.vue?vue&type=script&lang=js&"
import style0 from "./role-permission.vue?vue&type=style&index=0&id=c89eff50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c89eff50",
  null
  
)

export default component.exports